// app
export const ADD_EVENT_TAG = 'ADD_EVENT_TAG';
export const DELETE_EVENT_TAG = 'DELETE_EVENT_TAG';
export const LEAVE_CHANNEL = 'LEAVE_CHANNEL';
export const PATCH_EVENT = 'PATCH_EVENT';
export const RESET = 'RESET';
export const SET_ACTUAL_STREAM = 'SET_ACTUAL_STREAM';
export const SET_APP_STATE = 'SET_APP_STATE';
export const SET_APP_TYPE = 'SET_APP_TYPE';
export const SET_APP_MODE = 'SET_APP_MODE';
export const SET_AUTOPLAY = 'SET_AUTOPLAY';
export const SET_AUTOSTART_COUCH_MODE = 'SET_AUTOSTART_COUCH_MODE';
export const SET_COUCH_MODE = 'SET_COUCH_MODE';
export const SET_EVENT = 'SET_EVENT';
export const SET_EVENT_LINEUP = 'SET_EVENT_LINEUP';
export const SET_EVENT_STATS = 'SET_EVENT_STATS';
export const SET_EVENT_TAGS = 'SET_EVENT_TAGS';
export const SET_EVENT_ADS = 'SET_EVENT_ADS';
export const SET_IS_EMBEDDED = 'SET_IS_EMBEDDED';
export const SET_LEAGUE_TABLE = 'SET_LEAGUE_TABLE';
export const SET_EVENT_PERMISSIONS = 'SET_EVENT_PERMISSIONS';
export const SET_EVENT_BANNER_IMAGE_URL = 'SET_EVENT_BANNER_IMAGE_URL';
export const SET_LOGO_ENABLED = 'SET_LOGO_ENABLED';
export const SET_PLAYBACK_SPEED_ENABLED = 'SET_PLAYBACK_SPEED_ENABLED';
export const SET_QUALITY_SETTINGS_ENABLED = 'SET_QUALITY_SETTINGS_ENABLED';
export const SET_PLAYER_TYPE = 'SET_PLAYER_TYPE';
export const SET_STATE = 'SET_STATE';
export const SET_STREAM = 'SET_STREAM';
export const SET_TAGS = 'SET_TAGS';
export const SET_HIGHLIGHT_RULES = 'SET_HIGHLIGHT_RULES';
export const UPDATE_EVENT_TAG = 'UPDATE_EVENT_TAG';
export const SET_MATCHDAY_EVENTS = 'SET_MATCHDAY_EVENTS';
export const SET_MATCHDAY_REFERENCE_EVENT = 'SET_MATCHDAY_REFERENCE_EVENT';
export const SET_MATCHDAY_EVENT_CHANGE = 'SET_MATCHDAY_EVENT_CHANGE';
export const UPDATE_EVENT_SCORE = 'UPDATE_EVENT_SCORE';
export const SET_SYNC_WS = 'SET_SYNC_WS';
export const SET_EVENT_SUBSCRIPTION = 'SET_EVENT_SUBSCRIPTION';
export const SET_EVENT_STREAM_SUBSCRIPTION = 'SET_EVENT_STREAM_SUBSCRIPTION';
export const SET_EVENT_LINEUP_SUBSCRIPTION = 'SET_EVENT_LINEUP_SUBSCRIPTION';
export const SET_TIMELINE_ENABLED = 'SET_TIMELINE_ENABLED';
export const SET_TIMELINE_MINIMAL = 'SET_TIMELINE_MINIMAL';
export const SET_TIMELINE_SHOW_TAGS = 'SET_TIMELINE_SHOW_TAGS';
export const SET_PLAYER_TIME_ENABLED = 'SET_PLAYER_TIME_ENABLED';
export const SET_PLAYER_SEEK_ENABLED = 'SET_PLAYER_SEEK_ENABLED';
export const SET_PLAYER_PAUSE_ENABLED = 'SET_PLAYER_PAUSE_ENABLED';
export const SET_PLAYER_STOP_ENABLED = 'SET_PLAYER_STOP_ENABLED';
export const SET_PLAYER_LIVE_BADGE_ENABLED = 'SET_PLAYER_LIVE_BADGE_ENABLED';
export const SET_PLAYER_CONTENT_INFO_ENABLED = 'SET_PLAYER_CONTENT_INFO_ENABLED';
export const SET_PLAYER_FORCE_DISABLE_CHROMECAST = 'SET_PLAYER_FORCE_DISABLE_CHROMECAST';
export const SET_SHARING_ENABLED = 'SET_SHARING_ENABLED';
export const SET_LOOP_BACKGROUND_MODE = 'SET_LOOP_BACKGROUND_MODE';
export const SET_DISABLE_PROFILE = 'SET_DISABLE_PROFILE';
export const SET_DISABLE_ADS = 'SET_DISABLE_ADS';
export const SET_LOADED_STATUS = 'SET_LOADED_STATUS';
export const ADD_SCORE_SUBSCRIPTION = 'ADD_SCORE_SUBSCRIPTION';
export const REMOVE_SCORE_SUBSCRIPTION = 'REMOVE_SCORE_SUBSCRIPTION';
export const SET_DEBUG = 'SET_DEBUG';
export const SET_SCOREBOARD_SETTINGS = 'SET_SCOREBOARD_SETTINGS';
export const SET_PERIODS = 'SET_PERIODS';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_EVENT_TAGS_SUBSCRIPTIONS = 'SET_EVENT_TAGS_SUBSCRIPTIONS';
export const SET_EVENT_TAGS_ACTIVE_CHANNEL = 'SET_EVENT_TAGS_ACTIVE_CHANNEL';
export const SET_PLAYER_CUSTOM_TEXT = 'SET_PLAYER_CUSTOM_TEXT';
export const SET_PLAYER_CUSTOM_TEXT_ENABLED = 'SET_PLAYER_CUSTOM_TEXT_ENABLED';
export const SET_CINEMA_MODE = 'SET_CINEMA_MODE';
export const SET_PREVIEW_MODE = 'SET_PREVIEW_MODE';
export const SET_PREVIEW_DURATION = 'SET_PREVIEW_DURATION';
export const SET_GEOBLOCKED = 'SET_GEOBLOCKED';
export const SET_PREVIEW_LIMIT_REACHED = 'SET_PREVIEW_LIMIT_REACHED';
export const SET_FORCE_OVERLAY_VISIBLE = 'SET_FORCE_OVERLAY_VISIBLE';
export const SET_TAG_TEMPLATES = 'SET_TAG_TEMPLATES';
export const SET_TAGGING_TOOL_SETTINGS_OPEN = 'SET_TAGGING_TOOL_SETTINGS_OPEN';
export const SET_SHOW_TAG_GROUP_CREATE_PAGE = 'SET_SHOW_TAG_GROUP_CREATE_PAGE';
export const SET_SIDEBAR_OPEN = 'SET_SIDEBAR_OPEN';
// videos modules
export const ADD_DATA = 'ADD_DATA';
export const INCREASE_CURRENT_PAGE_COUNTER = 'INCREASE_CURRENT_PAGE_COUNTER';
export const SET_INITIAL_DATA_LOADED_STATE = 'SET_INITIAL_DATA_LOADED_STATE';
export const SET_CURRENT_PAGE_LOADED_STATE = 'SET_CURRENT_PAGE_LOADED_STATE';
export const SET_NR_OF_PAGES = 'SET_NR_OF_PAGES';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';

// videos module
export const SET_SORT_KEY = 'SET_SORT_KEY';
export const SET_VIDEOS = 'SET_VIDEOS';
export const SET_PARAMS = 'SET_PARAMS';

// tag edit
export const TAG_EDIT_SET_TAG = 'TAG_EDIT_SET_EDITING_TAG';
export const TAG_EDIT_SET_TAGS = 'TAG_EDIT_SET_BULK_EDITING_TAGS';
export const TAG_EDIT_SET_IS_SAVING = 'TAG_EDIT_SET_IS_SAVING';
export const TAG_EDIT_UPDATE_PROPS = 'TAG_EDIT_UPDATE_PROPS';
export const SET_TAG_LIST_ACTIVE_TAB = 'SET_TAG_LIST_ACTIVE_TAB';
export const SET_CLIP_LIST_ACTIVE_TAB = 'SET_CLIP_LIST_ACTIVE_TAB';
export const TAG_EDIT_EDIT_TIMESHIFT = 'TAG_EDIT_EDIT_TIMESHIFT';

// error
export const SET_PLAYER_ERROR = 'SET_PLAYER_ERROR';
export const SET_PLAYOUT_ERROR = 'SET_PLAYOUT_ERROR';

// user preferences
export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES';

// highlights
export const SET_HIGHLIGHT_DETECTION_STATE = 'SET_HIGHLIGHT_DETECTION_STATE';
export const SET_HIGHLIGHT_DETECTION_JOB = 'SET_HIGHLIGHT_DETECTION_JOB';
export const SET_HIGHLIGHT_DETECTION_ACTIVE = 'SET_HIGHLIGHT_DETECTION_ACTIVE';
